import moment, { Moment, MomentInput } from 'moment-timezone';

const TIMEZONE = 'America/Mexico_City'

export const UtilsService = {
  timeAgo: (date: any) => {
    const now: any = new Date();
    const seconds = Math.floor((now - date) / 1000);

    const intervals: any = {
      ["año"]: 31536000, // 365 días
      ["mes"]: 2592000, // 30 días
      ["día"]: 86400, // 24 horas
      ["hora"]: 3600, // 60 minutos
      ["minuto"]: 60, // 60 segundos
      ["segundo"]: 1,
    };

    let intervalType;

    for (const key in intervals) {
      const intervalValue = Math.floor(seconds / intervals[key]);
      if (intervalValue >= 1) {
        intervalType = key;
        return `Hace ${intervalValue} ${intervalType}${
          intervalValue > 1 ? "s" : ""
        }`;
      }
    }
    return "Justo ahora";
  },
  numberFormat: (text: number | bigint ) => {
    if(isNaN(Number(text))) {
      return 0;
    }
    let nf = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return nf.format(text);
  },
  dateFormat: (date: any, format = "DD/MM/YYYY · HH:mm") => moment(date).tz(TIMEZONE).format(format),
  round: (number: string | number) => +parseFloat(`${number}`).toFixed(2),
  formatRole: (role: string) => {
    switch (role) {
      case 'root':
        return 'Root';
      case 'admin':
        return 'Administrador';
      case 'capturist':
        return 'Capturista';
      default:
        return role;
    }
  },
};
